import React from 'react';
import { BridgeOverview } from '../../components/bridge/BridgeOverview';

export default function AdminDashboard() {
  return <BridgeOverview role="admin" />;
}
